import React,{Component} from 'react';
import {Modal,Button,Row,Col,Form} from 'react-bootstrap';
import axios from 'axios';

export  class EditTasksModal extends Component{
    constructor(props){
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            TaskList:[]
            
        }
      

    }
    componentDidMount() {
        
        
    }  
    
  
      
    handleSubmit(event){
        event.preventDefault();
        const options = {
            headers: {"content-type": "text/plain"}
        }
    const article = {taskid:event.target.taskid.value, taskname:event.target.taskname.value, taskheaderid:event.target.taskHeader.value,
        taskuniqueidentifier:event.target.uniqueIdentifier.value,
        taskmandatory:event.target.mandatory.value,username:this.props.username  };
    axios.post('https://as-mobilization-stage.accenture.com/KTPlanConfig/api/AdminTask/Post', article, options)
    .then((result)=> {            
        alert("Data saved successfully");
        this.props.filterchangetest(this.props.servicegroup,this.props.scope,this.props.level);
         },
         (error) => {
             alert('Failed to save data');
       }) 
       


    }

    render(){
        return (
            <div className='container'>
            <Modal  {...this.props} size='lg'  aria-labelledby='contained-modal-title-vcenter' centered >
                <Modal.Header>
                <Modal.Title id='contained-modal-title-vcenter'>
                    Add Task
                </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                          <Form onSubmit={this.handleSubmit}>

                          <Form.Group controlId='tasks'>
                              <div class="col-md-4" style={{display:'none'}}>
                              <Form.Label>TaskId</Form.Label>
                              <Form.Control type='text' style={{width:140}} name='taskid' required
                              disabled defaultValue={this.props.TaskId} ></Form.Control>
                              </div>
                           
                              
                          </Form.Group> 

                          <Form.Group controlId='tasks'>
                              <div class="col-md-6" >
                              <Form.Label>Task Name*</Form.Label>
                              <Form.Control as="textarea" maxLength={200} rows="2" style={{width:275}} defaultValue={this.props.TaskName}  name='taskname' required placeholder='Task Name'></Form.Control>
                              </div>
                             
                              <div class="col-md-6">
                              <Form.Label>Task Header*</Form.Label>
                              <Form.Select className='form-control' defaultValue={this.props.taskheaderid} style={{width:275,marginBottom:30}} name='taskHeader'  required>
                              {
                        
                                        this.props.HeaderList.map(list =>
                                        <option value={list.task_headerid} >{list.task_header}</option>)
                                }
                      
                              </Form.Select>
                             </div>

                             <div class="col-md-6">
                              <Form.Label>Unique Identifier*</Form.Label>
                              <Form.Control type='text' maxLength={10} style={{width:275}} defaultValue={this.props.unique} name='uniqueIdentifier' required ></Form.Control>

                              </div>
                              <div class="col-md-6">
                              <Form.Label>Mandatory*</Form.Label>
                              <Form.Select className='form-control' defaultValue={this.props.mandatory} style={{width:275}} name='mandatory'  required>
                                  <option value="1">Yes</option>
                                  <option value="0">No</option>
                              </Form.Select>
                              
                              </div>
                             
                             
                          </Form.Group>  
                          <Form.Group>
                              <Button variant='primary' style={{margin:10}} className='btn-new btn-confirm' type='submit'>
                                  Save
                              </Button> 
                              <Button onClick={this.props.onHide} style={{margin:10,backgroundColor:'gray'}} className='btn-new btn-confirm' >Close
                              </Button> 
                          </Form.Group>  
                          </Form>  
                        </Col>
                    </Row>
                </Modal.Body>
            
            </Modal>
            </div>
        )
    }
}